/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";
import {
  SIDENAV_WIDTH,
  SIDENAV_MINI_WIDTH,
  SIDENAV_GAP,
  SIDENAV_BREAKPOINT,
} from "app/navigation/Sidenav/constants";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "shared/components/MDBox";

// Material Dashboard 2 React context
import { useMaterialUIController, setLayout } from "app/providers";

function DashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, direction } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <MDBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        p: 3,
        position: "relative",

        [breakpoints.up(SIDENAV_BREAKPOINT)]: {
          [direction === "rtl" ? "marginRight" : "marginLeft"]: pxToRem(
            (miniSidenav ? SIDENAV_MINI_WIDTH : SIDENAV_WIDTH) + SIDENAV_GAP * 2
          ),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {children}
    </MDBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
